import React, { useEffect, useState } from "react";
import "./Development.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const statusMeta = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "completed") return { label: "पूर्ण", color: "#0F5C2E", tint: "#E8F3EA" };
  if (s === "ongoing" || s === "in-progress") return { label: "सुरू", color: "#C06A12", tint: "#FBF0E0" };
  return { label: "नियोजित", color: "#1466A8", tint: "#E7F0F8" };
};

const Development = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const res = await fetch(`${API}/api/development`);
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        setProjects(Array.isArray(data) ? data : []);
      } catch {
        setError("विकास प्रकल्प लोड करता आले नाहीत");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const shown = projects.filter((p) =>
    filter === "all" ? true : (p.status || "").toLowerCase() === filter
  );

  const FILTERS = [
    { key: "all", label: "सर्व" },
    { key: "ongoing", label: "प्रगतीपथावर" },
    { key: "completed", label: "पूर्ण झालेले" },
  ];

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / विकास कामे</div>
          <h1 className="rk-hero-title">विकास कामे</h1>
          <p className="rk-hero-sub">गावात सुरू असलेल्या व पूर्ण झालेल्या विकासकामांची पारदर्शक माहिती व प्रगती.</p>
        </div>
      </section>

      <section className="rk-wrap">
        {!loading && !error && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 26 }}>
            {FILTERS.map((f) => (
              <button key={f.key} className={`rk-chip ${filter === f.key ? "active" : ""}`} onClick={() => setFilter(f.key)}>{f.label}</button>
            ))}
          </div>
        )}

        {loading ? (
          <p className="rk-loading">विकास प्रकल्प लोड होत आहेत...</p>
        ) : error ? (
          <p className="rk-error">⚠️ {error}</p>
        ) : shown.length === 0 ? (
          <p className="rk-empty">कोणतेही विकास प्रकल्प उपलब्ध नाहीत</p>
        ) : (
          <div className="rk-cols rk-cols-3">
            {shown.map((p) => {
              const m = statusMeta(p.status);
              const img = p.images && p.images.length ? p.images[0] : null;
              return (
                <div key={p._id} className="rk-card rk-dev">
                  <div className="rk-dev-img">
                    {img ? <img src={img} alt={p.projectName} loading="lazy" /> : <div className="rk-dev-noimg">कामाचे छायाचित्र</div>}
                  </div>
                  <div style={{ padding: "20px 22px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 12.5, fontWeight: 700, color: m.color, background: m.tint, padding: "3px 12px", borderRadius: 100 }}>{m.label}</span>
                    </div>
                    <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 12, color: "#17241C", lineHeight: 1.35 }}>{p.projectName}</h3>
                    {p.description && <p style={{ fontSize: 14, color: "#5B6B60", marginTop: 6, lineHeight: 1.55 }}>{p.description}</p>}
                    <div style={{ marginTop: 16 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 6 }}>
                        <span style={{ color: "#5B6B60" }}>प्रगती</span>
                        <span style={{ fontWeight: 700, color: m.color }}>{p.progress}%</span>
                      </div>
                      <div style={{ height: 8, background: "#eef3ec", borderRadius: 100, overflow: "hidden" }}>
                        <div style={{ height: "100%", width: `${p.progress}%`, background: m.color, borderRadius: 100 }} />
                      </div>
                    </div>
                    <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px dashed #e0e8df", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 13, color: "#8a9990" }}>वापरलेला निधी</span>
                      <span style={{ fontWeight: 800, fontSize: 16, color: "#0F5C2E" }}>₹ {p.fundsUsed ? Number(p.fundsUsed).toLocaleString("en-IN") : "—"}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default Development;
